import React from 'react';

const SegmentUserFormModal = React.lazy(() => import('../components/FormModal'));
const segmentUserModalRegistry = {
    crm_segmentUserId: SegmentUserFormModal
};
export default segmentUserModalRegistry;
